import { type JSX, Match, Switch } from 'solid-js';

// The glyphs of Fleet Live's layout, sound and floating-Core controls (#6779, prototype
// `ICON.*`, `:3447-3454`, and the floating Core's buttons, `:4205-4209`). Decorative: every
// button that carries one names itself with its own label.

export type FleetLiveIconName =
  | 'move'
  | 'layout'
  | 'reset'
  | 'sound'
  | 'mute'
  | 'collapse'
  | 'expand'
  | 'up'
  | 'close'
  | 'resize';

export function FleetLiveIcon(props: { readonly name: FleetLiveIconName }): JSX.Element {
  const small = (): boolean =>
    props.name === 'collapse' ||
    props.name === 'expand' ||
    props.name === 'up' ||
    props.name === 'close';
  return (
    <svg
      width={props.name === 'resize' ? 10 : small() ? 12 : 14}
      height={props.name === 'resize' ? 10 : small() ? 12 : 14}
      viewBox={props.name === 'resize' ? '0 0 10 10' : '0 0 16 16'}
      fill="none"
      stroke="currentColor"
      stroke-width={small() ? 1.6 : 1.4}
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <Switch>
        <Match when={props.name === 'move'}>
          <path d="M8 1.5v13M1.5 8h13" />
          <path d="M6 3.5l2-2 2 2M6 12.5l2 2 2-2M3.5 6l-2 2 2 2M12.5 6l2 2-2 2" />
        </Match>
        <Match when={props.name === 'layout'}>
          <rect x="1.75" y="1.75" width="12.5" height="12.5" rx="2" />
          <path d="M1.75 5.5h12.5M10 5.5v8.75" />
        </Match>
        <Match when={props.name === 'reset'}>
          <path d="M5 4.5a5 5 0 11-1 5.2" />
          <path d="M4.6 1.6v3.2h3.2" />
        </Match>
        <Match when={props.name === 'sound'}>
          <path d="M2.5 6h2.5l3.5-3v10L5 10H2.5z" />
          <path d="M11 5.5a3.5 3.5 0 010 5M12.8 3.6a6 6 0 010 8.8" />
        </Match>
        <Match when={props.name === 'mute'}>
          <path d="M2.5 6h2.5l3.5-3v10L5 10H2.5z" />
          <path d="M11 6l3.5 4M14.5 6L11 10" />
        </Match>
        <Match when={props.name === 'collapse'}>
          <path d="M4 9.5l4 4 4-4M4 2.5h8" />
        </Match>
        <Match when={props.name === 'expand'}>
          <path d="M4 6.5l4-4 4 4M4 13.5h8" />
        </Match>
        <Match when={props.name === 'up'}>
          <path d="M8 13V3M3.5 7.5L8 3l4.5 4.5" />
        </Match>
        <Match when={props.name === 'close'}>
          <path d="M4 4l8 8M12 4l-8 8" />
        </Match>
        <Match when={props.name === 'resize'}>
          <path d="M1 9L9 1M1 5L5 1" />
        </Match>
      </Switch>
    </svg>
  );
}
